<template>
  <div class="flex flex-col items-center justify-center min-h-screen p-4 bg-white text-gray-800">
    <h1 class="text-3xl text-center font-bold mb-4 max-w-3xl">Oh snap! We don't support this version of your browser, <em>and neither should you!</em></h1>
    <p class="text-lg text-center mb-12 max-w-3xl">You are visiting this page because we detected an unsupported browser. Your browser does not support security features that we require. We highly recommend that you update your browser.</p>
    <ul class="grid grid-cols-3 justify-center justify-items-center items-center gap-8 text-lg text-center mb-6">
      <li>
        <a href="https://www.google.com/chrome/">
          <img src="https://cdn.jsdelivr.net/gh/alrra/browser-logos/src/chrome/chrome_128x128.png" alt="Google Chrome" class="mx-auto h-16">
          <span class="block mt-2">Google Chrome</span>
        </a>
      </li>
      <li>
        <a href="https://www.mozilla.org/en-US/firefox/new/">
          <img src="https://cdn.jsdelivr.net/gh/alrra/browser-logos/src/firefox/firefox_128x128.png" alt="Mozilla Firefox" class="mx-auto h-16">
          <span class="block mt-2">Mozilla Firefox</span>
        </a>
      </li>
      <li>
        <a href="https://www.microsoft.com/en-us/edge">
          <img src="https://cdn.jsdelivr.net/gh/alrra/browser-logos/src/edge/edge_128x128.png" alt="Microsoft Edge" class="mx-auto h-16">
          <span class="block mt-2">Microsoft Edge</span>
        </a>
      </li>
    </ul>
    <ul class="grid grid-cols-2 justify-center justify-items-center items-center gap-8 text-lg text-center mb-12">
      <li>
        <a href="https://www.apple.com/safari/">
          <img src="https://cdn.jsdelivr.net/gh/alrra/browser-logos/src/safari/safari_128x128.png" alt="Apple Safari" class="mx-auto h-16">
          <span class="block mt-2">Apple Safari</span>
        </a>
      </li>
      <li>
        <a href="https://www.opera.com/download">
          <img src="https://cdn.jsdelivr.net/gh/alrra/browser-logos/src/opera/opera_128x128.png" alt="Opera" class="mx-auto h-16">
          <span class="block mt-2">Opera</span>
        </a>
      </li>
    </ul>
    <p class="text-lg text-center">Once you have upgraded your browser, please try accessing the website again. Thank you!</p>
  </div>
</template>

<script setup lang="ts">
useSeoMeta({
  robots: 'noindex, nofollow'
})

definePageMeta({
  layout: 'full',
})

</script>

